module.exports = __webpack_public_path__ + "img/features-1.1671103a.png";